import { Undo2 } from "lucide-react";
import { posterUrl } from "../../lib/api";
import { useLang } from "../../lib/i18n";

export const versionLabel = (v, t) => (v.op === "upload" ? t("op_upload") : v.label && !v.label.startsWith("photo_") && !v.label.startsWith("video_") ? v.label : t(`op_${v.op}`));

export const VersionStrip = ({ project, onSelect, onUndo, busy }) => {
  const { t } = useLang();
  return (
    <div className="frz-versions" data-testid="version-strip">
      <button type="button" className="frz-btn frz-btn-ghost frz-btn-sm" onClick={onUndo}
        disabled={busy || project.current === 0} data-testid="button-undo">
        <Undo2 size={15} /> {t("undo")}
      </button>
      <div className="frz-versions-list">
        {project.versions.map((v, i) => (
          <button key={`${v.created_at}-${i}`} type="button" onClick={() => onSelect(i)} disabled={busy}
            className={`frz-version ${i === project.current ? "on" : ""}`} data-testid={`version-item-${i}`} title={versionLabel(v, t)}>
            {v.file && <img src={posterUrl(v.file)} alt="" />}
            <span>{i + 1}. {versionLabel(v, t)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
